import Vue from 'vue';

var tool = {
    methods: {
        showMsg(text) {
            return this.$message({
                showClose: true,
                message: text,
                type: 'warning'
            });
        },
        successMsg(text) {
            return this.$message({
                showClose: true,
                message: text,
                type: 'success'
            });
        },
        errorMsg(text) {
            return this.$message({
                showClose: true,
                message: text,
                type: 'error'
            });
        },
        confirm(text, callback, errcallback) {
            this.$confirm(text, '提示', {
                type: 'warning'
            }).then(() => {
                callback();
            }).catch(error => {
                errcallback();
                console.log(error)
            });
        }
    }
};

Vue.mixin(tool);